import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { MenuEnabledPageGuard } from 'src/app/guards/menu-enabled-page.guard';

import { RecommendationEditPage } from './recommendation-edit.page';

const routes: Routes = [
  {
    path: '',
    component: RecommendationEditPage
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RecommendationEditPageRoutingModule {}
